import {
    CHECK_EXPORTABILITY,
    CHECK_EXPORTABILITY_SUCCESS,
    CHECK_EXPORTABILITY_FAIL,
    CHECK_EXPORTABILITY_FETCHING,
    DELETE_DAILY_SUMMARY,
    DELETE_DAILY_SUMMARY_FAIL,
    DELETE_DAILY_SUMMARY_SUCCESS,
    CLEAR_DELETE_DAILY_SUMMARY
} from 'actions/dailySummaryActions.js';

const INITIAL_STATE = {
    isExportable: {}
};

const checkExportabilityFetching = (state, action) => {
    return {
        isExportable: {
            ...state.isExportable,
            [action.calendarDate]: {
                isExportable: null,
                isFetching: true
            }
        }
    };
};

const checkExportabilitySuccess = (state, action) => {
    return {
        isExportable: {
            ...state.isExportable,
            [action.calendarDate]: {
                isExportable: action.isExportable,
                isFetching: false
            }
        }
    };
};

const checkExportabilityFail = (state, action) => {
    return {
        ...state,
        isExportable: {
            ...state.isExportable,
            [action.calendarDate]: {
                isExportable: action.isExportable,
                isFetching: false
            }
        }
    };
};

const deleteDailySummaryFail = (state, action) => {
    return {
        ...state,
        deletingDailySummary: {
            ...state.deletingDailySummary,
            [action.calendarDate]: {
                isDeleting: false,
                isDeleted: false
            }
        }
    };
};

const deleteDailySummarySuccess = (state, action) => {
    return {
        ...state,
        deletingDailySummary: {
            ...state.deletingDailySummary,
            [action.calendarDate]: {
                isDeleting: false,
                isDeleted: true
            }
        }
    };
};

const clearDeleteDailySummaryState = (state, action) => {
    let newState = { ...state };

    if (newState && newState.deletingDailySummary && newState.deletingDailySummary[action.calendarDate]) {
        delete newState.deletingDailySummary[action.calendarDate];
    }

    return newState;
};

const handlers = {
    [CHECK_EXPORTABILITY_SUCCESS]: checkExportabilitySuccess,
    [CHECK_EXPORTABILITY_FAIL]: checkExportabilityFail,
    [CHECK_EXPORTABILITY_FETCHING]: checkExportabilityFetching,
    [DELETE_DAILY_SUMMARY_FAIL]: deleteDailySummaryFail,
    [DELETE_DAILY_SUMMARY_SUCCESS]: deleteDailySummarySuccess,
    [CLEAR_DELETE_DAILY_SUMMARY]: clearDeleteDailySummaryState
};

// ======= Actions =======
export function checkIfDailySummaryIsExportable(calendarDate, evictCache) {
    return {
        type: CHECK_EXPORTABILITY,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function deleteDailySummary(calendarDate, displayName) {
    return {
        type: DELETE_DAILY_SUMMARY,
        calendarDate: calendarDate,
        displayName: displayName
    };
}

export function clearDeleteDailySummary(calendarDate) {
    return {
        type: CLEAR_DELETE_DAILY_SUMMARY,
        calendarDate: calendarDate
    };
}

// ======= Selectors =======
export const getIsDailySummaryExportable = (state, calendarDate) => {
    return state.dailySummaryActions &&
        state.dailySummaryActions.isExportable &&
        state.dailySummaryActions.isExportable[calendarDate]
        ? state.dailySummaryActions.isExportable[calendarDate].isFetching ||
              state.dailySummaryActions.isExportable[calendarDate].isExportable
        : null;
};

export const isDailySummaryDeleted = (state, calendarDate) => {
    return state.dailySummaryActions &&
        state.dailySummaryActions.deletingDailySummary &&
        state.dailySummaryActions.deletingDailySummary[calendarDate]
        ? state.dailySummaryActions.deletingDailySummary[calendarDate].isDeleted
        : false;
};

// ======= Default =======
export default function isDailySummaryExportable(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
